import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import ActionSuccessSelected from "@/icons/Action/Success/Selected";
import { Icon } from "../Icon";

import styles from "./Checkbox.scss";

const CheckboxInput = ({
  value,
  id,
  name,
  disabled,
  isValid,
  required,
  checked: controlledChecked,
  customClass,
  onChange,
  ...restProps
}) => {
  const [lastControlledChecked, setLastControlledChecked] = useState(
    controlledChecked
  );
  const [checked, setChecked] = useState(controlledChecked);
  if (controlledChecked !== lastControlledChecked) {
    setLastControlledChecked(controlledChecked);
    setChecked(controlledChecked);
  }
  const [visitedOnce, setVisitedOnce] = useState(false);
  const [missingCheckmarkOnSubmit, setMissingCheckmarkOnSubmit] = useState();

  const changeChecked = (newChecked) => {
    if (disabled) {
      return;
    }
    setChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }

    if (missingCheckmarkOnSubmit && newChecked) {
      setMissingCheckmarkOnSubmit(false);
    }
  };

  const onCheckedChange = (event) => {
    changeChecked(event.target.checked);
  };

  const handleInvalid = (e) => {
    e.preventDefault();

    if (e.target.validity.valueMissing) {
      setMissingCheckmarkOnSubmit(true);
      return;
    }

    setMissingCheckmarkOnSubmit(false);
  };

  const shouldDisplayInvalid = () =>
    !isValid ||
    missingCheckmarkOnSubmit ||
    (required && !checked && visitedOnce);

  return (
    <>
      <input
        name={name}
        value={value}
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onCheckedChange}
        onBlur={() => setVisitedOnce(true)}
        onInvalid={handleInvalid}
        className={cx(
          "input",
          { "is-invalid": shouldDisplayInvalid() },
          customClass
        )}
        aria-invalid={shouldDisplayInvalid()}
        required={required}
        {...restProps}
      />
      <span className={styles.ci} aria-hidden="true">
        <span className={styles.icon}>
          <Icon icon={ActionSuccessSelected} size={Icon.Size.parent} />
        </span>
      </span>
    </>
  );
};

CheckboxInput.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  isValid: PropTypes.bool,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  customClass: PropTypes.string,
};

CheckboxInput.defaultProps = {
  value: "",
  name: "",
  isValid: true,
  checked: false,
  required: false,
  disabled: false,
  onChange: null,
  customClass: undefined,
};

CheckboxInput.displayName = "Checkbox.Input";

export default CheckboxInput;
